module.exports = __webpack_public_path__ + "img/wolf_1kl.4c354895.jpg";